<template>
    <Error>
        <NotFoundPage />
    </Error>
</template>

<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    
    const Error = defineAsyncComponent(() => import('~/layouts/error.vue'));
    const NotFoundPage = defineAsyncComponent(() => import('~/pages/NotFoundPage.vue'));
</script>
